import axios from 'axios';

const getCotacoes = params => axios.get('/cotacoes', {
  params,
});

export default {
  getCotacoes,
};
